export const getOccurrenceProps = (startEventDate, state, phrase) => {
    //TODO: Refactor for open selections
    return {
        dateTime: state.formatDate(startEventDate, state.config.currentTimeZone) || undefined,
        phrase: phrase || undefined
    };
};
//# sourceMappingURL=getOccurrenceProps.js.map